/**
 * Transparencia dels colors germans que no es poden comprar.
 *
 * La fila de miniatures (`snippets/hb-color-siblings.liquid`) mostra els altres
 * haramakis de la familia. Aqui s'hi apaguen els que NO es poden comprar amb la
 * seleccio que l'usuari te feta ara mateix.
 *
 * PER QUE EN JS I NO NOMES EN LIQUID. La fitxa es pinta abans que l'usuari triï
 * res, i "esgotat" depen de la seleccio SENCERA, no nomes de la talla: a
 * "XL / Gris claro" el Regular pot tenir estoc i l'Extralargo no. El Liquid
 * publica les combinacions disponibles de cada germa a `[data-hb-siblings-data]`
 * i aqui es rellegeix a cada canvi de variant.
 *
 * LA CLAU. Els valors de totes les opcions menys el color, unides per "|" i en
 * l'ordre del producte: "XL|Extralargo". El color se salta perque es el que
 * canvia entre germans; la seva posicio ve a `data-hb-color-index`.
 *
 * ⚠️ ELS GERMANS NO TENEN SEMPRE LES MATEIXES OPCIONS. Uns haramakis tenen
 * "Tamaño / Color" i altres "Tamaño / Color / Estilo", aixi que la clau d'un
 * ("M|Regular") no existeix mai al mapa de l'altre ("M"). Per aixo no n'hi ha
 * prou amb la cerca exacta: vegeu `matches()`.
 *
 * Mentre la seleccio no estigui completa no s'apaga res: sense saber la
 * combinacio no hi ha cap afirmacio a fer sobre la disponibilitat.
 */
(function () {
  'use strict';

  function readData(root) {
    var el = root.querySelector('[data-hb-siblings-data]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * La clau de la seleccio actual: els valors marcats menys el del color, en
   * l'ordre en que surten al selector. Torna null si encara no hi ha una opcio
   * triada per a cada posicio.
   */
  function selectionKey(picker, colorIndex) {
    if (!picker) return null;

    var fieldsets = picker.querySelectorAll('.option-selector');
    if (!fieldsets.length) return null;

    var parts = [];

    for (var i = 0; i < fieldsets.length; i++) {
      var checked = fieldsets[i].querySelector('.js-option:checked, option:checked');
      // Seleccio incompleta: no s'hi pot dir res.
      if (!checked || !checked.value) return null;
      if (i === colorIndex) continue;
      // Netejat igual que al Liquid, que en treu les cometes i les barres.
      parts.push(checked.value.replace(/["\\]/g, ''));
    }

    return parts.length ? parts.join('|') : null;
  }

  /**
   * El germa te estoc per a la seleccio `key`? Primer la cerca exacta, que es
   * el cas normal quan tots dos productes tenen les mateixes opcions. Si falla,
   * es compara nomes el que tenen en comu: n'hi ha prou que els valors de la
   * clau mes curta siguin tots a la mes llarga. Aixi, des d'un "M|Extralargo",
   * un germa sense estil i amb "M" disponible no s'apaga: te la talla, encara
   * que no l'estil (decisio del 23/09/2026).
   *
   * Es compara per valors i no per noms d'opcio, que varien ("Tamaño"/"Talla").
   */
  function matches(entry, key) {
    if (!entry) return false;
    if (entry[key]) return true;

    var selected = key.split('|');

    for (var combo in entry) {
      if (!Object.prototype.hasOwnProperty.call(entry, combo)) continue;

      var values = combo.split('|');
      var shorter = values.length < selected.length ? values : selected;
      var longer = shorter === values ? selected : values;
      var all = true;

      for (var i = 0; i < shorter.length; i++) {
        if (longer.indexOf(shorter[i]) === -1) {
          all = false;
          break;
        }
      }

      if (all) return true;
    }

    return false;
  }

  function update(root) {
    var data = readData(root);
    if (!data) return;

    var form = root.closest('form') || document;
    var picker = form.querySelector('variant-picker') || document.querySelector('variant-picker');
    var colorIndex = parseInt(root.getAttribute('data-hb-color-index'), 10);
    var key = selectionKey(picker, isNaN(colorIndex) ? -1 : colorIndex);

    var links = root.querySelectorAll('[data-hb-sibling]');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var entry = data[link.getAttribute('data-hb-sibling')];

      // Sense seleccio completa no s'apaga res. Amb seleccio, s'apaga el germa
      // que no tingui aquesta combinacio (o que no consti al mapa, que vol dir
      // sense estoc de res).
      var unavailable = key ? !matches(entry, key) : false;

      if (unavailable) {
        link.setAttribute('data-hb-unavailable', '');
      } else {
        link.removeAttribute('data-hb-unavailable');
      }
    }
  }

  function updateAll() {
    var roots = document.querySelectorAll('[data-hb-color-siblings]');
    for (var i = 0; i < roots.length; i++) update(roots[i]);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('variant-picker')) updateAll();
  });

  // El tema reemplaça el HTML del selector en canviar de variant i emet aquest
  // event un cop fet.
  document.addEventListener('on:variant:change', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
